import { useMutation, useQueryCache } from "react-query";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { notify } from "../../../../../common/helpers";
import { API_KEY_GET_MANAGEABLE_LIST } from "../constants";
import { postDeleteManageableListItem } from "../api/postDeleteManageableListItem";

export const usePostDeleteManageableListItem = () => {
  const queryCache = useQueryCache();
  const successMsg = _t("successfully_updated");

  return useMutation(postDeleteManageableListItem, {
    onSuccess: (data, variables) => {
      notify("success", successMsg);
      queryCache.invalidateQueries(API_KEY_GET_MANAGEABLE_LIST);
    },
  });
};
